import React from "react"
import { firestore } from "../../core"
import { usePushDevices } from "popopo-lib-front/firestore-access"
import * as FirebaseAuth from "firebase/auth"
import { UserDocument } from "popopo-msg"

export const UserDeviceList = (props: { firebase: FirebaseAuth.User; user: UserDocument }) => {
  const devices = usePushDevices(firestore, props.user.id, 100)

  return (
    <>
      <ul className="list-group w-100">
        {devices === "loading" ? (
          <li>
            <i className="fas fa-spin fa-spinner"/>
          </li>
        ) : devices.length === 0 ? (
          <li>デバイスは登録されていません。</li>
        ) : (
          devices.map((device) => (
            <li key={device.id}>
              Name: {device.id} (Created at: {device.created_at})
            </li>
          ))
        )}
      </ul>
    </>
  )
}
